import {VarcharDatatypeInterface} from '../postgresql/varchar-datatype.model';

export interface CurrencyCodeDataFieldInterface
  extends VarcharDatatypeInterface {
  data?: string;
}

export class CurrencyCodeDataFieldClass extends String
  implements CurrencyCodeDataFieldInterface {
  data?: string;
  max_length?: number;
  not_null?: boolean;
  is_unique?: boolean;
  default_value?: string;
}
